import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FormTaskState } from '../states/formTaskState';

const selectFormTaskState = createFeatureSelector<FormTaskState>('formTask');

export const selectTaskSendContentById = (id: number) => createSelector(
  selectFormTaskState,
  (formTaskState: FormTaskState) => formTaskState.sendTaskContents[id]
);
